const e={defaultProps:{disableRipple:!0}};export{e as MuiButtonBase};
//# sourceMappingURL=MuiButtonBase.js.map
